__turbopack_context__.v({
  "carouselImage": "Carousel-module__Khz4La__carouselImage",
  "root": "Carousel-module__Khz4La__root",
  "textContainer": "Carousel-module__Khz4La__textContainer",
});
